import React from 'react';
import PropTypes from 'prop-types';

import RecentRequests from './components/RecentRequests/RecentRequestsContainer';
import UpgradePrompt from '../../components/GeneralComponents/UpgradePrompt/UpgradePrompt';
import Modal from 'components/GeneralComponents/Modal';

import { getUserId } from '../../helpers/cookies';

import './RequestsPage.scss';
import styledConfirm from './components/styled';

import { RTOS_PER_PAGE, } from './constants';
import moment from 'moment';

const sha1 = require('js-sha1');

var checkCookie = function () {

  var lastCookie = document.cookie; // 'static' memory between function calls

  return function () {

    var currentCookie = document.cookie;

    if (currentCookie != lastCookie) {
      // something useful like parse cookie, run a callback fn, etc.
      if (currentCookie === "") {
        const backToPath = "/login";
        window.location.pathname = backToPath;
      }
      lastCookie = currentCookie; // store latest cookie
    }
  };
}();


class RequestsComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.mqttClient = props.mqttClient;
    this.mqttTopic = `user_event/${sha1(`user.${getUserId()}`)}`;
    this._messageHandler = null;

    this.state = {
      confirmationSheet: false,
      confirmationShift: undefined,
      confirmationConfigId: undefined,
      deletedGroupId: null,
      trigger: false,
      planName: '',
    };

    this.rtoPageIndex = 1;
    this.prevPageIndex = 1;
    this.apiCalled = false;
  }

  componentDidMount() {
    const { resetTotalRTOs, locationData, plans, locationId, allUsers, getScheduleUsers } = this.props;

    //Ensure componentDidUpdate called at lease once
    this.setState({ trigger: true });

    this.rtoPageIndex = 1;
    resetTotalRTOs();

    window.setInterval(checkCookie, 100); // run every 100 ms

    if (locationId) {
      if( allUsers == null || allUsers.length == 0){
        getScheduleUsers(locationId, 1, 10000)
      }
    }

    if (plans && plans.length > 0) {
      if (locationData && locationData.plan_id) {
        const cplan = plans.find(plan => plan.id === locationData.plan_id);
        this.setState({ planName: cplan.name });
      }
    }
  }

  getRTOStartAfter () {
    return  moment().subtract(2, 'week'); 
  }

  componentDidUpdate(prevProps, prevState) {
    const { locationId, getCostCenterData, locationConfig,
      getRequestTimeOffDispatch, getLocationEmployees,
      getLocationUsableSkills, getPendingUsers,
      getLocationInnerDepartments, departments,
      getLocationMyDepartments, myDepartments,
      getLocationEmployeesNew, totalRTOs, getLocationOnlineUsers, locationData, plans, } = this.props;

    if (!this.apiCalled) {
      if (locationId) {
        getCostCenterData(locationId);
        getLocationEmployeesNew(locationId);
        getLocationUsableSkills(locationId);
        getLocationInnerDepartments(locationId);
        getLocationMyDepartments(locationId);
        getRequestTimeOffDispatch(locationId, this.rtoPageIndex, RTOS_PER_PAGE, this.getRTOStartAfter());
        this.prevPageIndex = this.rtoPageIndex;
        this.rtoPageIndex += 1;

        this.mqttSubscribe();
      }
      this.apiCalled = true;
    }

    if (prevProps.totalRTOs !== totalRTOs) {
      // console.log(`page: ${this.rtoPageIndex - 1}, rto: ${totalRTOs.length}`);
      if (prevProps.totalRTOs) {
        if (totalRTOs.length - prevProps.totalRTOs.length === RTOS_PER_PAGE) {
          getRequestTimeOffDispatch(locationId, this.rtoPageIndex, RTOS_PER_PAGE, this.getRTOStartAfter());
          this.prevPageIndex = this.rtoPageIndex;
          this.rtoPageIndex += 1;
        }
      }
    }

    if (prevProps.locationData !== locationData) {
      if (plans && plans.length > 0) {
        if (locationData && locationData.plan_id) {
          const cplan = plans.find(plan => plan.id === locationData.plan_id);
          this.setState({ planName: cplan.name });
        }
      }
    }
  }

  componentWillUnmount() {
    if (this._messageHandler && this.mqttClient) {
      this.mqttClient.removeListener('message', this._messageHandler);
      this.mqttClient.unsubscribe(this.mqttTopic);
    }
  }

  mqttSubscribe = () => {
    if (!this.mqttClient) {
      console.warn('[RequestsComponent] MQTT client not available, skipping subscribe');
      return;
    }

    const { handleShiftUpdate, handleAddUserToOnlineList, handleRemoveUserFromOnlineList, } = this.props;

    this._messageHandler = (topic, payload) => {
      let message;
      try {
        message = JSON.parse(payload.toString());
      } catch (err) {
        console.error('[RequestsComponent] Failed to parse MQTT message:', err);
        return;
      }

      if (
        message.receiver_id == getUserId() &&
        message.event === 'shift' &&
        message.crud === 'UPDATE'
      ) {
        handleShiftUpdate(message.node_id);
      }
      if (
        message.receiver_id == getUserId() &&
        message.event === 'channel' &&
        message.crud === 'DELETE'
      ) {
        const msg = `Dash page: Group (channel) ${message.tree_id} has been deleted.`;
        console.log(msg);
        this.setState({ deletedGroupId: message.tree_id });
      }
    };

    this.mqttClient.on('message', this._messageHandler);
    this.mqttClient.subscribe(this.mqttTopic);
  };

  approveShiftClick = () => {
    const { approvePendingShift } = this.props;
    const { confirmationShift, confirmationConfigId } = this.state;
    approvePendingShift(confirmationShift, confirmationConfigId)
    this.toggleConfirmationSheet(undefined, undefined);
  }

  toggleConfirmationSheet = (shift, configId) => {
    this.setState((prevState) => ({
      confirmationSheet: !prevState.confirmationSheet,
      confirmationShift: shift,
      confirmationConfigId: configId
    }));
  };

  notifyRefreshRequested = () => {

    const { locationId, getRequestTimeOffDispatch } = this.props;
    this.rtoPageIndex = 1;
    getRequestTimeOffDispatch(locationId, this.rtoPageIndex, RTOS_PER_PAGE, this.getRTOStartAfter());
  }

  render() {
    const { deletedGroupId, planName } = this.state;
    const { locationConfig, } = this.props;

    return (
      <article>
        <RecentRequests
          notifyRefreshRequested={this.notifyRefreshRequested}
          toggleConfirmationSheet={this.toggleConfirmationSheet}
          deletedGroupId={deletedGroupId}
        />

        {planName === 'Basic' && <Modal>
          <UpgradePrompt />
        </Modal>}
        <styledConfirm.Overlay display={planName === 'Basic' ? 'block' : 'none'} />
      </article>
    );
  }
}

RequestsComponent.propTypes = {
  handleShiftUpdate: PropTypes.func.isRequired,
  approvePendingShift: PropTypes.func.isRequired,
  locationConfig: PropTypes.shape({}),
  mqttClient: PropTypes.object.isRequired,
};

RequestsComponent.defaultProps = {
  locationConfig: {},
};

export default RequestsComponent;

